const auth = {
  "form": {
    "login": "로그인",
    "signUp": "회원가입",
    "email": "이메일",
    "password": "비밀번호",
    "passwordConfirm": "비밀번호 확인",
    "forgotPassword": "비밀번호 찾기",
    "checkDuplicate": "중복확인",
    "next": "다음",
    "previous": "이전",
    "backToLogin": "로그인으로 돌아가기",
    "showPassword": "비밀번호 보기",
    "hidePassword": "비밀번호 숨기기",
    "id": "아이디",
    "name": "이름",
    "phone": "휴대폰 번호",
    "company": "소속",
    "job": "직무",
    "field": "분야",
    "userInfo": "회원정보",
    "verificationCode": "인증 코드",
    "resending": "재전송 중...",
    "verifying": "확인 중...",
    "fieldOptions": {
      "design": "설계",
      "construction": "시공",
      "maintenance": "유지보수",
      "safetyInspection": "안전진단",
      "survey": "측량",
      "agriculture": "농업",
      "environment": "환경"
    }
  },
  "validation": {
    "emailRequired": "이메일을 입력해주세요",
    "emailInvalid": "올바른 이메일 형식이 아닙니다",
    "passwordRequired": "비밀번호를 입력해주세요",
    "passwordConfirmRequired": "비밀번호 확인을 입력해주세요",
    "passwordMinLength": "비밀번호는 8자 이상이어야 합니다",
    "nameRequired": "이름을 입력해주세요",
    "phoneRequired": "휴대폰 번호를 입력해주세요",
    "phoneInvalid": "올바른 휴대폰 번호 형식이 아닙니다",
    "companyRequired": "소속을 입력해주세요",
    "jobRequired": "직무를 입력해주세요",
    "fieldRequired": "분야를 선택해주세요",
    "fieldPlaceholder": "선택해주세요",
    "codeRequired": "인증번호를 입력해주세요",
    "codeSixDigits": "6자리 숫자를 입력해주세요"
  },
  "message": {
    "loginFailed": "로그인 실패",
    "confirmFailed": "인증 실패",
    "resendingConfirmationCode": "인증 코드를 재발송 했습니다.",
    "confirmationCodeResendingFail": "재전송 실패",
    "fillEmail": "기존에 가입하신 이메일을 입력해주세요.",
    "sendCodeNumber": "인증번호를 보내드립니다.",
    "sentCodeNumber": "인증번호가 발송되었습니다.",
    "sendCodeNumberFailed": "인증번호 전송 실패",
    "changePassWordFailed": "비밀번호 변경 실패",
    "passwordChangeSuccess": "비밀번호가 성공적으로 변경되었습니다.",
    "passwordChangeFailed": "비밀번호 변경 실패",
    "notMatchCode": "인증번호는 6자리 숫자입니다.",
    "signUpFailed": "회원가입에 실패했습니다",
    "signupRetry": "가입 처리를 완료하지 못했습니다. 잠시 후 다시 시도해주세요.",
    "finishingSignup": "가입이 마무리되지 않은 계정입니다. 가입을 마무리합니다.",
    "verificationCodeSendFailed": "인증번호 발송 실패",
    "verificationCodeSendFailedMessage": "인증번호 발송에 실패했습니다. 다시 요청 해주세요.",
    "getVerificationCode": "인증번호 받기",
    "supersededNotice": "다른 기기에서 같은 계정으로 이 앱에 로그인하여 로그아웃되었습니다. 계속하려면 다시 로그인해 주십시오.",
    "supersededPartnerNotice": "다른 기기에서 같은 계정으로 이 앱에 로그인하여 로그아웃되었습니다. 계속하려면 하이보드에서 다시 접속해 주십시오.",
    "claimSuperseded": "다른 기기에서 이 앱에 더 최근에 로그인했습니다. 다시 로그인해 주십시오.",
    "claimUnavailable": "로그인을 확인하지 못했습니다. 잠시 후 다시 시도해 주십시오.",
    "autoLoginFailed": "자동 로그인에 실패했습니다. 다시 시도해 주십시오."
  },
  "deviceConflict": {
    "title": "다른 기기에서 사용 중인 계정입니다",
    "body": "한 계정은 앱마다 한 번에 한 기기에서만 로그인할 수 있습니다. 여기서 로그인하면 이 앱을 사용 중인 다른 기기는 로그아웃됩니다.",
    "cancel": "취소",
    "confirm": "로그인"
  }
} as const;

export default auth;
